import About from './sections/About'
import Contact from './sections/Contact'
import Overlay from './sections/Overlay'
import Partners from './sections/Partners'
import Studio from './sections/Studio'
import Team from './sections/Team'
import Events from './sections/Events'

export default function Home() {
	return <>
		<About />

		<Studio />

		<Overlay />

		<Team />

		<Contact />

		<Events />

		<Partners />
	</>
}
